export default "__VITE_ASSET__Jahszgtx__"